import React, { useState } from "react";
import { Element, FeeDetails } from "../../../Interface/scheduler/form";
import { Box, Link } from "@mui/material";
import { getFeeWrapperBackgroundColor } from "../../../utility/utility";
import {
  showLessText,
  SESSION_INSPECTION_FEE_DATA,
  SESSION_INSPECTION_FEE_VALUE,
  maxReadTextLength,
} from "../../../constants/constant";

const FeeContent = ({
  element,
  conceptCode,
  feeDetails,
}: {
  element: Element;
  conceptCode: string;
  feeDetails: FeeDetails;
}) => {
  const { elementType, id, DisplayFeeSection } = element;

  const {
    heading = "",
    subheading = "",
    text = "",
    inspectionFee = "",
    learnMoretext = "",
  } = feeDetails || {};

  const inspectionFeeValue = sessionStorage.getItem(
    SESSION_INSPECTION_FEE_VALUE
  );

  const feeValue =
    inspectionFee !== "" ? Number(inspectionFee.replace("$", "")) : null;

  const fee =
    inspectionFeeValue && inspectionFeeValue !== "null"
      ? Number(inspectionFeeValue)
      : feeValue;

  const inspectionFeeData = {
    heading: feeDetails?.heading || "",
    subheading: feeDetails?.subheading || "",
    text: feeDetails?.text || "",
    inspectionFee: feeValue?.toString() || "",
    learnMoretext: feeDetails?.learnMoretext,
  };

  sessionStorage.setItem(
    SESSION_INSPECTION_FEE_DATA,
    JSON.stringify(inspectionFeeData)
  );

  const showFees = sessionStorage.getItem("showFees");

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  };

  const displayedText =
    isExpanded || (text && text.length <= maxReadTextLength)
      ? text
      : `${text?.slice(0, maxReadTextLength)}...`;

  const checkFeeConditions =
    showFees !== "true" ||
    (fee !== null && Number(fee) === 0) ||
    DisplayFeeSection !== true;

  if (checkFeeConditions) {
    return null;
  } else {
    return (
      <Box
        className={`${elementType || ""} ${id || ""}`}
        sx={{
          backgroundColor: getFeeWrapperBackgroundColor(conceptCode),
          padding: "1em 0",
          marginBottom: "1em",
          borderRadius: "10px",
        }}
        data-testid="fee-content-root"
      >
        <h2 className="fee-heading" data-testid="fee-content-heading">
          {heading}
        </h2>
        {Boolean(fee) && fee > 0 && (
          <h3
            className="fee-sub-heading"
            data-testid="fee-content-subheading"
            dangerouslySetInnerHTML={{
              __html: subheading.replace("{fee}", `<b> $${fee} </b>`),
            }}
          ></h3>
        )}
        <p className="fee-text" data-testid="fee-content-text">
          {displayedText}
        </p>
        {text && text.length > maxReadTextLength && (
          <Link
            onClick={handleToggle}
            sx={{ color: "primary.dark", cursor: "pointer" }}
            href="#"
            className="fee-link"
            aria-label={isExpanded ? `${showLessText}` : `${learnMoretext}`}
            underline="none"
            data-testid="fee-content-toggle-link"
          >
            {isExpanded ? `${showLessText}` : `${learnMoretext}`}
          </Link>
        )}
      </Box>
    );
  }
};

export default FeeContent;
